module.exports = __webpack_public_path__ + "static/media/ic_categories_football.feb44052.svg";